module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "show-more"
  }, [_c('p', {
    staticClass: "clickable show-more-toggle",
    on: {
      "click": function($event) {
        return _vm.onClick()
      }
    }
  }, [_vm._v(_vm._s(_vm.isVisible ? _vm.locale.t('label_show_less') : _vm.locale.t('label_show_more')) + "\n    "), _c('i', {
    class: _vm.isVisible ? 'ti-arrow-circle-up' : 'ti-arrow-circle-down'
  })])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-6deb04b1!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Shared/ShowMore.vue
// module id = 786
// module chunks = 0